/**
 * Language Select Dropdown
 */

import { h } from "preact";
import { LanguageInfo } from "../../../types/rootDataTypes";
import { Icon } from "../../shared/components";

type SelectType = {
  sortedLangs: LanguageInfo[];
  langChange: (val: string) => void;
};

const LanguageSelect = ({ sortedLangs, langChange }: SelectType) => {
  return (
    <div class="LanguageSelect-dropdown">
      <label class="LanguageSelect-label" for="languages">
        <Icon type="language" style="LanguageSelect-icon" />
        Language
      </label>
      <select
        class="LanguageSelect-select"
        name="available-languages"
        id="languages"
        onChange={(e) => langChange(e.currentTarget.value)}
      >
        {sortedLangs.map(({ browser_navigator_code, name }) => {
          return (
            <option key={browser_navigator_code} value={browser_navigator_code}>
              {name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default LanguageSelect;
